//import moment from "moment";
import moment from 'moment-timezone';
moment.tz.setDefault("Asia/Bangkok");
export default moment
